import { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { Form, Formik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ContentCard,
  SelectGeneric,
  Label,
  Input,
  Button,
  Switch
} from 'ypf-pas-general-ui-components';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { Col } from 'react-bootstrap';

import MainTitle from '../../../components/MainTitle/MainTitle';
// eslint-disable-next-line prettier/prettier
import HeaderTable from
'../../../components/WorkReports/ViewOptionsContainer/DailyView/LineTableContainer/HeaderTable';
import NoWorkReports from '../../../components/WorkReports/NoWorkReports';
import LineRowTemplate from '../../../components/LineRowTemplate/LineRowTemplate';
import LoaderContext from '../../../context/LoaderProvider';
import AddMultiplePLModal from '../../../components/WorkReports/AddMultiplePLModal/AddMultiplePLModal';
import FooterButtonTemplate from '../../../components/FooterButtonTemplate/FooterButtonTemplate';
import useToast from '../../../hooks/useToast';
import { mapperAllArray, mapperBusinessUnit } from '../../../utils/mapper';
import { getNroContractsOfUser } from '../../../services/adminContracts';
import CustomCheck from '../../../components/MonthlyServiceRequest/CustomCheck/CustomCheck';
import NoUbications from '../../../components/MonthlyServiceRequest/NoData/NoUbications';
import ModalAddLocation from '../../../components/WorkReports/MonthlyWorkReport/ModalAddLocation/ModalAddLocation';
import useRequestDetailPermissions from '../../../hooks/useRequestDetailPermissions';
import UbicationAccordion from '../../../components/MonthlyServiceRequest/CustomAccordion/UbicationAccordion';
import AddPLToUbicationModal from '../../../components/MonthlyServiceRequest/Modals/AddPLToUbicationModal/AddPLToUbicationModal';
import { MONTHS } from '../../../utils/formatUtils';
import { monthlyTemplateUbicationsAdapter } from '../../../adapters/generateTemplate/ubicationsAdapter';
import DeleteUbicationModal from '../../../components/MonthlyServiceRequest/Modals/DeleteUbicationModal';
import useUbicationAccordion from '../../../hooks/useUbicationAccordion';
import { postCreateTemplate } from '../../../services/templateWorkReport';
import useMultiplPositionAndLine from '../../../hooks/useMultiplePositionAndLine';
import useGetParamsForWorkReportTemplate from '../../../hooks/useGetParamsForWorkReportTemplate';
import useLocationForWorkReportTemplate from '../../../hooks/useLocationForWorkReportTemplate/useLocationsForWorkReportTemplate';
import { notifyEnum } from '../../../constants/constants';

const getInitialTemplateMonthlyState = (state) =>
  state && 'isSDS' in state ? !state.isSDS : false;

const getInitialContractsState = (state) =>
  state?.contractNumber
    ? [
        {
          id: state.contractNumber,
          nombre: `${state.contractNumber}`
        }
      ]
    : [];

const getInitialContractSelectedState = (state) =>
  state?.contractNumber
    ? {
        value: state.contractNumber,
        label: `${state.contractNumber}`
      }
    : undefined;

const GenerateTemplate = () => {
  const location = useLocation();
  const { state } = location;

  const [positionLineValueProps, setPositionLineValueProps] = useState([]);
  const [showModalAddLine, setShowModalAddLine] = useState(false);
  const [nameTemplate, setNameTemplate] = useState('');
  const [isTemplateMonthly, setIsTemplateMonthly] = useState(getInitialTemplateMonthlyState(state));
  const [contracts, setContracts] = useState(getInitialContractsState(state));
  const [contractSelected, setContractSelected] = useState(getInitialContractSelectedState(state));
  const [deleteUbicationInfo, setDeleteUbicationInfo] = useState({ id: null, nombre: null });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const today = Date.now();
  const year = new Date(today).getFullYear().toString();
  const monthNumber = new Date(today).getMonth() + 1;
  const month = MONTHS[monthNumber];

  const { permissions } = useRequestDetailPermissions({ notifyTo: notifyEnum.provider });
  const workPartPermissions = permissions?.workPart;

  const history = useHistory();
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();
  const nombre = 'Generar Plantilla';
  const urlTemplateWR = '/manage-temp/workReport';
  const { paramsLocation, setBusinessUnitsAndOperationsAvailables } =
    useGetParamsForWorkReportTemplate({
      permissions
    });

  const initialValues = {};
  const form = useRef();

  const {
    isAllAccordionsSelecteds,
    handleSelectAll,
    handleUnselectAll,
    accordionsSelecteds,
    changeSetAccordionsSelecteds,
    changeAddPLToUbicationState,
    handleOpenModalAddLocation,
    handleCloseModalAddLocation,
    modalAddLocation,
    closeAccordions,
    handleOpenAccordion,
    showAddPLToUbicationModal
  } = useUbicationAccordion({});

  const {
    locations,
    tipoNegocio,
    setUbicationsAcc,
    handleDeleteUbication,
    handleUpdateLocationData,
    handleSubmitPosLines
  } = useLocationForWorkReportTemplate({ isEdit: false, accordionsSelecteds });

  const { positions } = useMultiplPositionAndLine({
    contractNumber: contractSelected?.value,
    isMonthly: isTemplateMonthly
  });

  const onClose = () => {
    setShowModalAddLine(false);
  };

  const areAllSelected = isAllAccordionsSelecteds(accordionsSelecteds, locations);

  const isSubmitDisabled = !(
    (!!positionLineValueProps.length || !!locations.length) &&
    nameTemplate.length > 0 &&
    !!contractSelected.value
  );

  const isContractSelectDisable = positionLineValueProps?.length !== 0 || locations?.length !== 0;

  const showAddPLtoUbicationButton = !!locations.length && isTemplateMonthly;

  const isMonthlySwitchDisable = !!locations?.length || !!positionLineValueProps?.length;

  const areBuAndOperationsFetched =
    !paramsLocation?.disabledChangeUunn &&
    !state?.contractNumber &&
    (paramsLocation?.optionsBusinessOptions?.length > 0 ||
      paramsLocation?.optionsOperations?.length > 0);

  const fetchNroContract = useCallback(async () => {
    try {
      setLoader(true);
      const body = {
        unidadesNegocioIds: paramsLocation.optionsBusinessOptions?.map((uunn) => uunn.id),
        operacionesIds: paramsLocation.optionsOperations?.map((op) => op.id)
      };
      const response = await getNroContractsOfUser(body);

      setContracts(mapperBusinessUnit(response));
      setLoader(false);
    } catch (err) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  }, [
    paramsLocation.optionsBusinessOptions,
    paramsLocation.optionsOperations,
    setLoader,
    setNewToast
  ]);

  const handleClick = ({ position, line }) => {
    const { idPosicion } = position;
    const { idLinea } = line;

    const temporal = positionLineValueProps.filter((data) => {
      const { line: lin, position: pos } = data;

      if (pos.id !== idPosicion) return data;
      if (lin.id !== idLinea) return data;

      return null;
    });

    setPositionLineValueProps(temporal);
  };

  const handleChangeSelect = (selectedContract) => {
    const operationIds = selectedContract?.operationsIds?.length
      ? selectedContract?.operationsIds
      : [];

    const businessUnitsIds = selectedContract?.businessUnitsIds?.length
      ? selectedContract?.businessUnitsIds
      : [];

    setBusinessUnitsAndOperationsAvailables({ businessUnitsIds, operationIds });
    setContractSelected({
      value: selectedContract.id,
      label: selectedContract.label
    });
  };

  const handleChangeInput = (e) => {
    setNameTemplate(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      setLoader(true);
      const body = {
        numeroContrato: contractSelected?.value,
        nombrePlantilla: nameTemplate,
        esMensualizada: isTemplateMonthly,
        tipoNegocio,
        ubicaciones: isTemplateMonthly ? monthlyTemplateUbicationsAdapter(locations) : null,
        plantillaParteTrabajoLineaSds: !isTemplateMonthly
          ? mapperAllArray(positionLineValueProps)
          : null
      };

      const response = await postCreateTemplate(body);

      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: response?.mensaje
      });
      // En esta validacion no distingue si es SDS o MSDS
      if (state && 'isSDS' in state) history.push({ pathname: state?.pathname, template: true });
      else history.push(urlTemplateWR);
    } catch (err) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const updateDeleteUbicationInfo = (idUbication, nombreUbication) => {
    setDeleteUbicationInfo({ id: idUbication, nombre: nombreUbication });
  };

  const onClickExit = () => {
    if (state && 'isSDS' in state) {
      history.push(state?.pathname);
    } else {
      history.push(urlTemplateWR);
    }
  };

  const handleSetPositionLineValueProps = (pLArray) => {
    const posLineExists = positionLineValueProps.some((pL) =>
      pLArray.some(
        (posLine) =>
          posLine.position.numeroPosicion === pL.position.numeroPosicion &&
          posLine.line.numeroLinea === pL.line.numeroLinea
      )
    );

    if (!posLineExists) {
      setNewToast({
        type: 'SUCCESS',
        message: 'Posición y línea agregada correctamente'
      });

      return setPositionLineValueProps((currentState) => currentState.concat(pLArray));
    }
    if (posLineExists) {
      setNewToast({
        type: 'ERROR',
        message: 'Ya existe la posicion y línea'
      });
    }

    return positionLineValueProps;
  };

  useEffect(() => {
    if (areBuAndOperationsFetched) fetchNroContract();
  }, [fetchNroContract, paramsLocation, areBuAndOperationsFetched]);

  useEffect(() => {
    const getBusinessUnits = async () => {
      if (
        !state?.contractNumber ||
        (!paramsLocation.optionsBusinessOptions.length &&
          !paramsLocation?.optionsOperations?.length)
      )
        return;

      const body = {
        unidadesNegocioIds: paramsLocation.optionsBusinessOptions?.map((uunn) => uunn.id),
        operacionesIds: paramsLocation?.optionsOperations?.map((op) => op.id) ?? []
      };

      const response = await getNroContractsOfUser(body);
      const contractsList = mapperBusinessUnit(response);
      const contractFound = contractsList.find((contract) => contract.id === +state.contractNumber);

      if (contractFound) {
        const operationIds = contractFound?.operationsIds?.length
          ? contractFound?.operationsIds
          : [];

        const businessUnitsIds = contractFound?.businessUnitsIds?.length
          ? contractFound?.businessUnitsIds
          : [];

        setBusinessUnitsAndOperationsAvailables({ businessUnitsIds, operationIds });
      }
    };

    getBusinessUnits();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    paramsLocation.optionsBusinessOptions.length,
    paramsLocation.optionsOperations.length,
    state?.contractNumber
  ]);

  return (
    <>
      <div className="container">
        <MainTitle isSDS={state} nombre={nombre} previusPath={urlTemplateWR} />
        {/* {!isModal && <MainTitle nombre={nombre} />} */}
        <div className="my-4">
          <ContentCard orientation="vertical-horizontal">
            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
              <Col>
                <Label icon="" label="Nombre de la plantilla" size="md" sizeValue="md" value="" />
                <Input
                  className="w-100 mb-4"
                  maxLength={50}
                  name="Input"
                  onChange={handleChangeInput}
                  placeholder="Ingrese el nombre de la plantilla"
                  type="text"
                  value={nameTemplate}
                />
              </Col>
              <div className="text-center">
                <Switch
                  checked={isTemplateMonthly}
                  className="pt-2 px-2 SwitchAccordion"
                  color="primary-secondary"
                  disabled={isMonthlySwitchDisable}
                  labelPlacement="bottom"
                  name="Mensualizada"
                  onChange={() => {
                    setIsTemplateMonthly(!isTemplateMonthly);
                  }}
                  size="sm"
                  sizeLabel="sm"
                  title="Mensualizada"
                />
              </div>
            </div>

            <Label className="mb-4" icon="" label="Contrato" size="md" sizeValue="md" value="" />
            <div className="d-flex justify-content-between ">
              <SelectGeneric
                isDisabled={isContractSelectDisable}
                onChange={handleChangeSelect}
                options={contracts.length !== 0 ? contracts : []}
                placeholder="Selecciona contrato"
                value={contractSelected}
              />
              {showAddPLtoUbicationButton && (
                <div className="d-flex justify-content-between align-items-center w-90">
                  <div className="d-flex">
                    <CustomCheck
                      isChecked={areAllSelected}
                      onChange={() => {
                        if (areAllSelected) {
                          handleUnselectAll();
                        } else {
                          handleSelectAll(locations);
                        }
                      }}
                    />
                    <Button
                      className="mx-2"
                      colorIcon="primary"
                      disabled={accordionsSelecteds.length === 0}
                      icon={AiOutlinePlusCircle}
                      iconRight
                      label="Agregar posición y línea a ubicaciones"
                      onClick={() => changeAddPLToUbicationState(true)}
                      sizeIcon="17px"
                      type="button"
                      variant="light-gray"
                      widthButton="300px"
                    />
                  </div>
                </div>
              )}

              {!isTemplateMonthly ? (
                <Button
                  colorIcon="primary"
                  disabled={!contractSelected?.value}
                  fontSizeLabel="15px"
                  icon={AiOutlinePlusCircle}
                  iconRight
                  label="Agregar líneas al parte"
                  onClick={() => setShowModalAddLine(true)}
                  sizeIcon="17px"
                  type="button"
                  variant="light-gray"
                  widthButton="200px"
                />
              ) : (
                <Button
                  colorIcon="primary"
                  disabled={!contractSelected?.value}
                  fontSizeLabel="15px"
                  icon={AiOutlinePlusCircle}
                  iconRight
                  label="Agregar ubicación"
                  onClick={() => handleOpenModalAddLocation()}
                  sizeIcon="17px"
                  type="button"
                  variant="light-gray"
                  widthButton="200px"
                />
              )}
            </div>

            <hr />
            {!isTemplateMonthly &&
              (positionLineValueProps?.length ? (
                <ul className="list_container">
                  <HeaderTable isSDS={!!state?.isSDS} tableTemplate />
                  <Formik initialValues={initialValues} innerRef={form}>
                    {() => (
                      <Form>
                        {positionLineValueProps?.map((data) => (
                          <li key={data?.line}>
                            <LineRowTemplate
                              amount={data?.amount}
                              handleClick={() => handleClick(data)}
                              isSDS={!!state?.isSDS}
                              line={data?.line}
                              position={data?.position}
                              templateComponent
                            />
                          </li>
                        ))}
                      </Form>
                    )}
                  </Formik>
                </ul>
              ) : (
                <NoWorkReports
                  subtitle="Agregá las posiciones y líneas para generar las plantillas"
                  title="No disponés de ninguna posición y línea"
                />
              ))}
            {isTemplateMonthly && (
              <div className="location-workreports-container">
                {locations?.length ? (
                  <>
                    {locations && (
                      <>
                        {locations.length > 0 &&
                          locations.map((ubication, ubicationIndex) => (
                            <UbicationAccordion
                              IOPermissions
                              accordionData={ubication}
                              accordionsSelecteds={accordionsSelecteds}
                              asignationType={3}
                              byUbication
                              closeAccordions={closeAccordions}
                              disabledEditStateCancelOrFinish={false}
                              handleOpenAccordion={handleOpenAccordion}
                              handleUpdateLocationData={handleUpdateLocationData}
                              hasPositionLines={ubication.tienePosicionLinea}
                              isTemplate
                              key={ubication.id}
                              month={month}
                              newLineAdded
                              setAccordionsSelecteds={changeSetAccordionsSelecteds}
                              setShowAddPLToUbicationModal={changeAddPLToUbicationState}
                              setShowDeleteModal={setShowDeleteModal}
                              ubicationIndex={ubicationIndex}
                              updateDeleteUbicationInfo={updateDeleteUbicationInfo}
                              workPartPermissions={workPartPermissions}
                              year={year}
                            />
                          ))}
                        <AddPLToUbicationModal
                          contractNumber={contractSelected?.value}
                          isTemplate
                          month={month}
                          onSubmit={handleSubmitPosLines}
                          setShowAddPLToUbicationModal={changeAddPLToUbicationState}
                          showAddPLToUbicationModal={showAddPLToUbicationModal}
                          ubicationsSelecteds={locations.filter((ubication) =>
                            accordionsSelecteds.includes(ubication.id)
                          )}
                          year={year}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <NoUbications />
                )}
              </div>
            )}
          </ContentCard>
        </div>
        <FooterButtonTemplate
          isDisabled={isSubmitDisabled}
          name="Generar plantilla"
          onClickExit={onClickExit}
          onClickFunction={handleSubmit}
        />
      </div>
      <AddMultiplePLModal
        contractNumber={state?.contractNumber ? state?.contractNumber : contractSelected?.value}
        onCloseModal={onClose}
        onSubmitPL={(values) => handleSetPositionLineValueProps(values)}
        positions={positions}
        showModal={showModalAddLine}
      />
      <ModalAddLocation
        canAddWellToImputationObject
        canEditImputationObject
        handleSubmit={setUbicationsAcc}
        isTemplate
        notFilterTypeOptions={false}
        onClose={handleCloseModalAddLocation}
        params={paramsLocation}
        show={modalAddLocation.show}
      />
      <DeleteUbicationModal
        handleDeleteUbication={handleDeleteUbication}
        setShowDeleteModal={setShowDeleteModal}
        showDeleteModal={showDeleteModal}
        ubicationId={deleteUbicationInfo.id}
        ubicationName={deleteUbicationInfo.nombre}
      />
    </>
  );
};

export default GenerateTemplate;
